<div class="content">
	<div>
		<form
			id="workForm"
			name="workForm"
			[formGroup]="changePasswordForm"
			enctype="application/x-www-form-urlencoded"
		>
			<section class="cambioPwd form">
				<h2>{{ "changePassword.private.changePassword" | translate }}</h2>
				<div class="field col-sm-12">
					<p
						dir="ltr"
						[innerHTML]="'formato-password.p1' | translate"
					></p>
				</div>
				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_newPwd">{{ "changePassword.private.newPassword" | translate }}</label>
					<input
						type="password"
						id="b2bCambioPwd_newPwd"
						name="b2bCambioPwd_newPwd"
						formControlName="password"
						maxlength="30"
						(ngModelChange)="changePasswordForm.updateValueAndValidity()"
					/>
				</div>
				<div class="field col-sm-offset-3 col-sm-6">
					<label for="b2bCambioPwd_confirmPwd">{{ "changePassword.private.confirmPassword" | translate }}</label>
					<input
						type="password"
						id="b2bCambioPwd_confirmPwd"
						name="b2bCambioPwd_confirmPwd"
						formControlName="confPassword"
						maxlength="30"
						(ngModelChange)="changePasswordForm.updateValueAndValidity()"
					/>
				</div>
				<div class="col-sm-12 text-center">
					<span id="cambia_fieldsContainer">
						<a
							[class.disabled]="changePasswordForm.invalid || !isValid()"
							(click)="changePassword()"
							class="btn btn-red"
						>
							{{ "changePassword.private.change" | translate }}
						</a>
					</span>
				</div>
			</section>
		</form>
	</div>
</div>